// extracted by mini-css-extract-plugin
export var csatScore = "_m8-5";
export var header = "_m8-1";
export var panelWrapper = "_m8-2";
export var postPreview = "_m8-3";
export var rightContent = "_m8-0";
export var wrappingText = "_m8-4";